import EcoNavProduct, { EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { productPageUrl, productPageTheme, shopNowLink } from '../../config/pageConfig';
import styles from './index.module.scss';
import { LangText } from './LangText';
import getLocal from '@/app/utils/i18n';

export default function ProductNav({ activeTab, tabCallback }: { activeTab: string; tabCallback?: any }) {
    const { locale } = getLocal();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const linkMap = shopNowLink[locale] || shopNowLink.us;

    const tabChange = (item: any, index: number) => {
        tabCallback && tabCallback(item.value);
    };

    const data: EcoNavProductProps = {
        productItems: [
            {
                value: 'd3s',
                label: TextA.product_name,
                href: thePageUrl,
            },
        ],
        tabItems: [],
        buyItems: [
            {
                value: 'Button',
                label: TextA.btn_buy,
                href: linkMap.nav,
            },
        ],
        theme: productPageTheme,
        onTabChange: tabChange,
        defaultTabActiveKey: activeTab,
    };

    return (
        <div className={styles.comp}>
            <EcoNavProduct {...data} />
        </div>
    );
}
